import styled from 'styled-components';
import { motion } from 'framer-motion6';
import { sizes } from 'style';

export const ItemContainer = styled(motion.div)`
  display: grid;
  grid-template-columns: 11px 1fr;
  grid-gap: 16px;
`;

export const Label = styled.div`
  border-radius: 10px;
  background-color: ${({ background }) => background};
`;

export const ContentWrapper = styled.div`
  > h5 {
    font-size: 18px;
    font-weight: 700;
    line-height: 32px;
    margin-bottom: 6px;
    margin-top: 0px;

    @media ${sizes.tabletLandscape} {
      font-size: 24px;
    }
  }

  > p {
    margin: 0px;
    font-size: 16px;
    line-height: 24px;
  }
`;
